import { Capacitor } from '@capacitor/core';

/**
 * Native logger that logs to Android logcat and iOS console
 * This ensures our debug messages appear in device logs
 */
export class NativeLogger {
  private static logToNative(level: 'debug' | 'info' | 'warn' | 'error', message: string, ...args: any[]) {
    const fullMessage = `[AstroShifts] ${message} ${args.length > 0 ? JSON.stringify(args) : ''}`;
    
    // Always log to browser console
    console[level](fullMessage);
    
    // Also log to native if available
    if (Capacitor.isNativePlatform()) {
      try {
        // Use Capacitor's native logging capability
        (Capacitor as any).logjs?.(level, fullMessage);
      } catch (e) {
        // Fallback - this might show in logcat
        console.log(`NATIVE_LOG_${level.toUpperCase()}: ${fullMessage}`);
      }
    }
  }

  static debug(message: string, ...args: any[]) {
    this.logToNative('debug', message, ...args);
  }

  static info(message: string, ...args: any[]) {
    this.logToNative('info', message, ...args);
  }

  static warn(message: string, ...args: any[]) {
    this.logToNative('warn', message, ...args);
  }

  static error(message: string, ...args: any[]) {
    this.logToNative('error', message, ...args);
  }
}